import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";

function Header() {
  return (
    <Navbar collapseOnSelect expand="md" bg="white" variant="light" className="shadow-sm">
      <Container>
        <Navbar.Brand as={NavLink} to="/" className="d-flex align-items-center gap-2">
          <img
            src="/brand/applogo-1024.png"
            width="32"
            height="32"
            alt="Family Ring"
            className="me-2"
            style={{ borderRadius: 7 }}
          />
          <span className="brand-name">Family Ring</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="nav-primary" />
        <Navbar.Collapse id="nav-primary">
          <Nav className="ms-auto">
            <Nav.Link as={NavLink} to="/" end>
              Home
            </Nav.Link>
            <Nav.Link as={NavLink} to="/install">
              Install
            </Nav.Link>
            <Nav.Link as={NavLink} to="/about">
              About
            </Nav.Link>
            <Nav.Link as={NavLink} to="/support">
              Support
            </Nav.Link>
            <Nav.Link as={NavLink} to="/legalDocs">
              Legal
            </Nav.Link>
            <Nav.Link
              href="https://app.familyring.io"
              className="ms-md-2 btn btn-sm px-3 rounded-pill"
              style={{ background: 'var(--brand-primary)', color: '#fff', lineHeight: '1.8' }}
            >
              Web Login
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
